import { useEffect, useRef } from "react";

/** Reusable modal wrapper.
 * - Closes on Escape
 * - Closes on backdrop click (clicks inside content do not close)
 * - Locks body scroll while open
 */
export default function Modal({ open, onClose, children, className = "", "data-testid": testId = "modal", ariaLabel }) {
  const ref = useRef(null);
  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => { if (e.key === "Escape") onClose?.(); };
    document.addEventListener("keydown", onKey);
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = prevOverflow;
    };
  }, [open, onClose]);
  if (!open) return null;
  return (
    <div
      onClick={() => onClose?.()}
      className="fixed inset-0 z-50 bg-black/70 backdrop-blur-sm flex items-center justify-center p-4"
      data-testid={`${testId}-backdrop`}
      role="dialog"
      aria-modal="true"
      aria-label={ariaLabel || "Dialog"}
    >
      <div
        ref={ref}
        onClick={(e) => e.stopPropagation()}
        className={`csc-card max-w-lg w-full max-h-[90vh] overflow-auto ${className}`}
        data-testid={testId}
      >
        {children}
      </div>
    </div>
  );
}
